<template>
	<div class="home">
		<center>
			<br>
			<img alt="logo" src="../assets/img/logo.svg" :width="width">
		</center>
	</div>
</template>

<script>
import {  mapGetters } from 'vuex'

export default {
	data() {
		return {
			width: '450px'		
		}
	},
	computed: {
    ...mapGetters(['isMobileDevice'])
  },
	created() {
		if(this.isMobileDevice) this.width = '320px'
	}
}
</script>